#import "../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation EntityDocumentProtection($input: EntityDocumentRowProtectionInput!) {
  entityDocumentRowProtection(input: $input) {
    entityDocument {
      ...EntityDocumentsFields
      extractionType {
        isExtractProtected
      }
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
    }
  }
}
